import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { NutriDietsSubRoute } from "./Constants/routes";

const NutriDiets = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {NutriDietsSubRoute.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/nutri-diets/all" />
      </Switch>
    </>
  );
};

export default NutriDiets;
